/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  AMORTIZATION_BANNER_DISCLAIMER: 'calculators.amortize.amortization.banner.disclaimer',
  CALCULATOR_BANNER_DISCLAIMER: 'calculators.amortize.calculator.banner.disclaimer',
  CALCULATOR_LABEL_INTERESTRATE: 'calculators.amortize.calculator.label.interestRate',
  CALCULATOR_LABEL_LOANAMOUNT: 'calculators.amortize.calculator.label.loanAmount',
  INTIALTERMS_LABEL_INTERESTRATE: 'calculators.amortize.intitalTerms.label.interestRate',
  INTIALTERMS_LABEL_LOANAMOUNT: 'calculators.amortize.intitalTerms.label.loanAmount',
  INTIALTERMS_LABEL_MONTHLYPAYMENT: 'calculators.amortize.intitalTerms.label.monthlyPayment',
  INTIALTERMS_LABEL_NUMBEROFMONTHS: 'calculators.amortize.intitalTerms.label.numberOfMonths',
  RESULTSDATA_LABEL_INTERESTSAVINGS: 'calculators.amortize.resultsData.label.interestSavings',
  RESULTSDATA_LABEL_PAYOFFDATE: 'calculators.amortize.resultsData.label.payoffDate',
  RESULTSDATA_LABEL_SHORTENLOANBY: 'calculators.amortize.resultsData.label.shortenLoanBy',
  RESULTSDATA_PAYLUMPSUM_LABEL_NEWLOANAMOUNT: 'calculators.amortize.resultsData.payLumpSum.label.newLoanAmount',
  SCHEDULECHART_DESKTOPCALCULATEDNAME_BALANCE: 'calculators.amortize.scheduleChart.desktopCalculatedName.balance',
  SCHEDULECHART_DESKTOPCALCULATEDNAME_INTEREST: 'calculators.amortize.scheduleChart.desktopCalculatedName.interest',
  SCHEDULECHART_DESKTOPCALCULATEDNAME_PRINCIPAL: 'calculators.amortize.scheduleChart.desktopCalculatedName.principal',
  SCHEDULECHART_MOBILECALCULATEDNAME_BALANCE: 'calculators.amortize.scheduleChart.mobileCalculatedName.balance',
  SCHEDULECHART_MOBILECALCULATEDNAME_INTEREST: 'calculators.amortize.scheduleChart.mobileCalculatedName.interest',
  SCHEDULECHART_MOBILECALCULATEDNAME_PRINCIPAL: 'calculators.amortize.scheduleChart.mobileCalculatedName.principal',
  SCHEDULECHART_NAME_BALANCE: 'calculators.amortize.scheduleChart.name.balance',
  SCHEDULECHART_NAME_INTEREST: 'calculators.amortize.scheduleChart.name.interest',
  SCHEDULECHART_NAME_PRINCIPAL: 'calculators.amortize.scheduleChart.name.principal',
  SCHEDULETABLE_COLUMN_CUMULATIVEINTEREST: 'calculators.amortize.scheduleTable.column.cumulativeInterest',
  SCHEDULETABLE_COLUMN_CUMULATIVEPRINCIPAL: 'calculators.amortize.scheduleTable.column.cumulativePrincipal',
  SCHEDULETABLE_COLUMN_ENDINGBALANCE: 'calculators.amortize.scheduleTable.column.endingBalance',
  SCHEDULETABLE_COLUMN_INTERESTPAYMENT: 'calculators.amortize.scheduleTable.column.interestPayment',
  SCHEDULETABLE_COLUMN_PAYMENTDATE: 'calculators.amortize.scheduleTable.column.paymentDate',
  SCHEDULETABLE_COLUMN_PAYMENTNUMBER: 'calculators.amortize.scheduleTable.column.paymentNumber',
  SCHEDULETABLE_COLUMN_PRINCIPALPAYMENT: 'calculators.amortize.scheduleTable.column.principalPayment',
  SCHEDULETABLE_COLUMN_STARTINGBALANCE: 'calculators.amortize.scheduleTable.column.startingBalance',
  TOOLTIP_AMORTIZATION_TEXT_1: 'calculators.amortize.tooltip.amortization.text1',
  TOOLTIP_AMORTIZATION_TEXT_2: 'calculators.amortize.tooltip.amortization.text2',
  TOOLTIP_PAYLUMPSUM_TEXT_1: 'calculators.amortize.tooltip.payLumpSum.text1',
  TOOLTIP_PAYMOREMONTHLY_TEXT_1: 'calculators.amortize.tooltip.payMoreMonthly.text1',
};

const enMessages = {
  // Amortization Calculator Form
  [IDS.AMORTIZATION_BANNER_DISCLAIMER]: 'The amortization calculator is intended for fixed-rate loans.',
  [IDS.CALCULATOR_LABEL_INTERESTRATE]: 'Interest Rate',
  [IDS.CALCULATOR_LABEL_LOANAMOUNT]: 'Loan Amount',
  [IDS.INTIALTERMS_LABEL_INTERESTRATE]: 'Interest Rate',
  [IDS.INTIALTERMS_LABEL_LOANAMOUNT]: 'Loan Amount',
  [IDS.INTIALTERMS_LABEL_MONTHLYPAYMENT]: 'Monthly Payment',
  [IDS.INTIALTERMS_LABEL_NUMBEROFMONTHS]: 'Number of Months',
  // Amortization Schedule Chart
  [IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_BALANCE]: 'Calculated Balance',
  [IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_INTEREST]: 'Calculated Cumulative Interest',
  [IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_PRINCIPAL]: 'Calculated Cumulative Principal',
  [IDS.SCHEDULECHART_MOBILECALCULATEDNAME_BALANCE]: 'Calculated Balance',
  [IDS.SCHEDULECHART_MOBILECALCULATEDNAME_INTEREST]: 'Calculated Interest',
  [IDS.SCHEDULECHART_MOBILECALCULATEDNAME_PRINCIPAL]: 'Calculated Principal',
  [IDS.SCHEDULECHART_NAME_BALANCE]: 'Current Balance',
  [IDS.SCHEDULECHART_NAME_INTEREST]: 'Current Interest',
  [IDS.SCHEDULECHART_NAME_PRINCIPAL]: 'Current Principal',
  // Amortization Schedule Table
  // eslint-disable-next-line sort-keys
  [IDS.SCHEDULETABLE_COLUMN_CUMULATIVEINTEREST]: 'Cumulative Interest',
  [IDS.SCHEDULETABLE_COLUMN_CUMULATIVEPRINCIPAL]: 'Cumulative Principal',
  [IDS.SCHEDULETABLE_COLUMN_ENDINGBALANCE]: 'Ending Balance',
  [IDS.SCHEDULETABLE_COLUMN_INTERESTPAYMENT]: 'Interest Payment',
  [IDS.SCHEDULETABLE_COLUMN_PAYMENTDATE]: 'Payment Date',
  [IDS.SCHEDULETABLE_COLUMN_PAYMENTNUMBER]: 'Pmt.',
  [IDS.SCHEDULETABLE_COLUMN_PRINCIPALPAYMENT]: 'Principal Payment',
  [IDS.SCHEDULETABLE_COLUMN_STARTINGBALANCE]: 'Starting Balance',
  // Pay More Monthly, Pay Lump Sum
  // eslint-disable-next-line sort-keys
  [IDS.CALCULATOR_BANNER_DISCLAIMER]: 'This calculator is intended for fixed-rate loans.',
  [IDS.RESULTSDATA_LABEL_INTERESTSAVINGS]: 'Interest Savings',
  [IDS.RESULTSDATA_LABEL_PAYOFFDATE]: 'Payoff Date',
  [IDS.RESULTSDATA_LABEL_SHORTENLOANBY]: 'Shorten the Loan by',
  [IDS.TOOLTIP_AMORTIZATION_TEXT_1]: 'This is an estimated amortization schedule based on your calculations. The chart compares your calculated payment scenario to your current terms.',
  [IDS.TOOLTIP_AMORTIZATION_TEXT_2]: 'Download your calculated amortization schedule to see the payment breakdown over the life of your loan.',
  [IDS.TOOLTIP_PAYLUMPSUM_TEXT_1]: 'Drag the slider to see how making a lump sum payment can shorten your payoff date. Or type in an amount in the text field.',
  [IDS.TOOLTIP_PAYMOREMONTHLY_TEXT_1]: 'Drag the slider to see how additional monthly payments can shorten your payoff date. Or type in an amount in the text field.',
};

const enMurabahaMessages = {
  ...enMessages,
  // Amortization Calculator Form
  [IDS.AMORTIZATION_BANNER_DISCLAIMER]: 'The amortization calculator is intended for fixed-rate accounts.',
  [IDS.CALCULATOR_LABEL_INTERESTRATE]: 'Profit Rate',
  [IDS.CALCULATOR_LABEL_LOANAMOUNT]: 'Account Amount',
  [IDS.INTIALTERMS_LABEL_INTERESTRATE]: 'Profit Rate',
  [IDS.INTIALTERMS_LABEL_LOANAMOUNT]: 'Account Amount',
  // Amortization Schedule Chart
  // eslint-disable-next-line sort-keys
  [IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_INTEREST]: 'Calculated Cumulative Profit',
  [IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_PRINCIPAL]: 'Calculated Cumulative Purchase Commitment',
  [IDS.SCHEDULECHART_MOBILECALCULATEDNAME_INTEREST]: 'Calculated Profit',
  [IDS.SCHEDULECHART_MOBILECALCULATEDNAME_PRINCIPAL]: 'Calculated Purchase Commitment',
  [IDS.SCHEDULECHART_NAME_INTEREST]: 'Current Profit',
  [IDS.SCHEDULECHART_NAME_PRINCIPAL]: 'Current Purchase Commitment',
  // Amortization Schedule Table
  // eslint-disable-next-line sort-keys
  [IDS.SCHEDULETABLE_COLUMN_CUMULATIVEINTEREST]: 'Cumulative Profit',
  [IDS.SCHEDULETABLE_COLUMN_CUMULATIVEPRINCIPAL]: 'Cumulative Purchase Commitment',
  [IDS.SCHEDULETABLE_COLUMN_INTERESTPAYMENT]: 'Profit Payment',
  [IDS.SCHEDULETABLE_COLUMN_PRINCIPALPAYMENT]: 'Purchase Commitment Payment',
  // Pay More Monthly and Pay Lump Sum Results
  // eslint-disable-next-line sort-keys
  [IDS.CALCULATOR_BANNER_DISCLAIMER]: 'This calculator is intended for fixed-rate accounts.',
  [IDS.RESULTSDATA_LABEL_INTERESTSAVINGS]: 'Profit Savings',
  [IDS.RESULTSDATA_LABEL_PAYOFFDATE]: 'Discounted Murabaha Debt Payoff Date',
  [IDS.RESULTSDATA_LABEL_SHORTENLOANBY]: 'Shorten the Murabaha Financing Transaction by',
  [IDS.TOOLTIP_AMORTIZATION_TEXT_2]: 'Download your calculated amortization schedule to see the payment breakdown over the life of your account.',
  [IDS.TOOLTIP_PAYLUMPSUM_TEXT_1]: 'Drag the slider to see how making a lump sum payment can shorten your discounted Murabaha debt payoff date. Or type in an amount in the text field.',
  [IDS.TOOLTIP_PAYMOREMONTHLY_TEXT_1]: 'Drag the slider to see how additional monthly payments can shorten your discounted Murabaha debt payoff date. Or type in an amount in the text field.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
